import { doFetchHeroContent } from '@/services/hero_content.service';
import { doFetchCmsList, doFetchPageList } from '@/services/cache.service';
import { getField, updateField } from 'vuex-map-fields';
import  config  from '../../config/index'
const { product } = config
import humps from 'lodash-humps';

export const layout = {
    namespaced: true,
    state: {
        user: {
            userVisits: localStorage.getItem('cr_userVisitCount') ? localStorage.getItem('cr_userVisitCount') : 0
        },
        categoryQueryParam: {
            pageSize: '',
            pageNo: '',
            sortSelect: '',
            categoryId: '',
            search: '',
            sideFilter: ''
        },
        product,
        inProgress: false,
        heroContent: {},
        cmsBlockContent:{},
        snackbar: {
            show: false,
            message: null,
            color: null,
            timeout: 0
        },
        paymentCount:1,
        pageContent:{}
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        inProgress(state, yesOrNo) {
            state.inProgress = yesOrNo
        },
        setCategoryQueryParam(state, data) {
            state.categoryQueryParam = data;
        },
        setHeroContent(state, content) {
            state.heroContent = content
        },
        setCmsBlockContent(state, content) {
            state.cmsBlockContent = content
        },
        setPageContent(state, content) {
            state.pageContent = content
        },
        setSnackbar(state, obj) {
            state.snackbar = obj;
        },
        setPaymentCount(state, count) {
            state.paymentCount = count;
        },
    },
    actions: {
        updateCategoryQueryParam({ commit }, values) {
            commit('setCategoryQueryParam', values);
        },
        fetchHeroContent: async({ commit }, categoryId) => {
            try {
                commit('inProgress', true);
                const heroContent = await doFetchHeroContent(categoryId);
                if (heroContent) {
                    commit('inProgress', false);
                    commit('setHeroContent', humps(heroContent));
                }
                return humps(heroContent);
            } catch (error) {
                commit('inProgress', false);
                throw error
            }
        },
        showSnackbar({ commit }, obj) {
            commit('setSnackbar', obj);
        },
        setHeroContent({ commit }, one) {
            commit('setHeroContent', humps(one));
        },
        fetchCmsBlock: async({ commit }) => {
            try {
                commit('inProgress', true);
                const blockContent = await doFetchCmsList();
                if (blockContent) {
                    commit('inProgress', false);
                    commit('setCmsBlockContent', humps(blockContent));
                }
            } catch (error) {
                commit('inProgress', false);
                throw error
            }
        },
        fetchPageContent: async({ commit }) => {
            try {
                commit('inProgress', true);
                const pageContent = await doFetchPageList();
                if (pageContent) {
                    commit('inProgress', false);
                    commit('setPageContent', humps(pageContent));
                }
            } catch (error) {
                commit('inProgress', false);
                throw error
            }
        },
        setPaymentCount({ commit }, count) {
            commit('setPaymentCount', count);
        },
    }

};